import React, {useState } from 'react';
import {Table, Spinner, Button } from 'react-bootstrap';
import { endpoint } from '../../utils/api';
//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faUpload } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faFolderOpen,faUpload)
const ReportsTable = ({reports, users}) => {

    const [IDLoading, setIDLoading] = useState("");

    const openFile = async (id) => {
       return Word.run(async (context) => {
        let url = endpoint + "/reports/open/" + id;
        fetch(url, 
          {
            headers: {
               Authorization: 'Bearer '+ localStorage.token
           }
          }).then(async function (response) {
            response.json().then(async function (data) {
            let text = Buffer.from(data.file, "hex").toString("base64");
            context.application.createDocument(text).open();            
            setIDLoading("");
            return context.sync();
          });
        });
      });
        
    }

    return (
        <Table striped bordered hover>
        <thead>
            <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            {reports.map((r) => {
                  return <tr>
                          <td>{r.name}</td>
                          <td>{r.description}</td>
                          <td>
                          <div style={{width: '100%'}}>
                                <div style={{display: "inline-block", paddingLeft: '3px', paddingRight: '3px'}}> 
                                  <Button className="primary-button border-button" size="1x" onClick={() => {openFile(r._id); setIDLoading(r._id)}} disabled={r._id === IDLoading}>
                                      {r._id !== IDLoading ?                                      
                                        <FontAwesomeIcon icon={faFolderOpen}  size='1x' className='all-font-icons' />
                                       :
                                       <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                          variant="light"
                                       />
                                      }
                                    </Button>
                                  </div>

                          </div>
                      </td>
  
                      </tr>          
            })}
        </tbody>
        
    </Table>
    
    )
}


export default ReportsTable